import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface statusPopupState {
  open: boolean;
  status: string | null;
  message: string | null;
  locationPath?: string | null;
  isFunction?: boolean;
  locationFunction?: any;
  buttonStatus: boolean;
  btnStatus?: string;
  refreshValue: any;
  anotherDeviceAuth: boolean;
  title?: string;
  isShowCloseIcon?: string;
}

const initialState: statusPopupState = {
  open: false,
  status: null,
  message: null,
  locationPath: null,
  buttonStatus: false,
  refreshValue: 0,
  anotherDeviceAuth: false,
  locationFunction: null,
  isFunction: false,
  title: "",
  isShowCloseIcon: "YES"
};

const statusPopupSlice = createSlice({
  name: "statusPopup",
  initialState,
  reducers: {
    setStatusPopup(state, action) {
      state.title = action.payload.title;
      state.open = true;
      state.status = action.payload.status;
      state.message = action.payload.message;
      state.buttonStatus = action.payload.buttonStatus;
      state.locationFunction = action.payload.locationFunction;
      state.isFunction = action.payload.isFunction;
      state.isShowCloseIcon = action.payload.isShowCloseIcon === "NO" ? action.payload.isShowCloseIcon : "YES";
      if (action.payload.anotherDeviceAuth) {
        state.anotherDeviceAuth = action.payload.anotherDeviceAuth;
      }
      if (action.payload.locationPath)
        state.locationPath = action.payload.locationPath;
    },

    clearStatusPopup(state) {
      state.open = false;
      state.locationPath = null;
      state.anotherDeviceAuth = false;
      state.locationFunction = null;
      state.isFunction = false;
      state.title = "";
    },
    refreshStatusPopup(state, action) {
      state.refreshValue = action.payload;
    },
  },
});

export const { setStatusPopup, clearStatusPopup, refreshStatusPopup } =
  statusPopupSlice.actions;
export const statusPopupSelector = (state: RootState) => state?.statusPopup;
export default statusPopupSlice.reducer;
